import { FC } from "react";
import { Box, IconButton } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

interface ExpandableIdCellProps {
  id: string;
  isExpanded: boolean;
  onToggle: () => void;
}

const ExpandableIdCell: FC<ExpandableIdCellProps> = ({ id, isExpanded, onToggle }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      width: "100%",
    }}
  >
    <IconButton
      size="small"
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        onToggle();
      }}
      onMouseDown={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
      tabIndex={-1}
    >
      {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
    </IconButton>
    <span>{id}</span>
  </Box>
);

export default ExpandableIdCell;
